/**
 * Live "days until deadline" for savings findings.
 *
 * The persisted deadline (`periodEnd`) is stored as UTC midnight of the
 * deadline date. To keep the count consistent with the daily server-side
 * refresh (which runs on the UTC calendar), the count rolls over at the UTC
 * day boundary: both the deadline and "today" are reduced to their UTC
 * calendar dates before differencing. Clamped at 0; falls back to the number
 * stored at analysis time when no deadline date exists.
 */
export function liveDaysUntil(
  periodEnd: string | Date | null | undefined,
  storedDaysUntil?: number | null,
  now: Date = new Date(),
): number | null {
  if (periodEnd != null) {
    const d = periodEnd instanceof Date ? periodEnd : new Date(periodEnd);
    if (!isNaN(d.getTime())) {
      const endUtc = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
      const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
      return Math.max(0, Math.round((endUtc - todayUtc) / 86_400_000));
    }
  }
  return typeof storedDaysUntil === "number" ? storedDaysUntil : null;
}
